/**
 * @generated SignedSource<<bf1507fbe17b115c9e56ed562f9f8e73>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type UpdateUserGroupMembersInput = {
  add?: ReadonlyArray<any> | null | undefined;
  groupUUID: any;
  remove?: ReadonlyArray<any> | null | undefined;
};
export type UpdateUserGroupMembersMutation$variables = {
  input: UpdateUserGroupMembersInput;
};
export type UpdateUserGroupMembersMutation$data = {
  readonly updateUserGroupMembers: {
    readonly problems: ReadonlyArray<{
      readonly message: string;
    }>;
    readonly userGroup: {
      readonly id: string;
    } | null | undefined;
  };
};
export type UpdateUserGroupMembersMutation = {
  response: UpdateUserGroupMembersMutation$data;
  variables: UpdateUserGroupMembersMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "concreteType": "UserGroup",
  "kind": "LinkedField",
  "name": "userGroup",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "message",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "UpdateUserGroupMembersMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdateUserGroupMembersPayload",
        "kind": "LinkedField",
        "name": "updateUserGroupMembers",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "problems",
            "plural": true,
            "selections": [
              (v3/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "UpdateUserGroupMembersMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdateUserGroupMembersPayload",
        "kind": "LinkedField",
        "name": "updateUserGroupMembers",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "problems",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__typename",
                "storageKey": null
              },
              (v3/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "414b2abc5d82e762feacdff8d307d379",
    "id": null,
    "metadata": {},
    "name": "UpdateUserGroupMembersMutation",
    "operationKind": "mutation",
    "text": "mutation UpdateUserGroupMembersMutation(\n  $input: UpdateUserGroupMembersInput!\n) {\n  updateUserGroupMembers(input: $input) {\n    userGroup {\n      id\n    }\n    problems {\n      __typename\n      message\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "f224af9ca258bfe34fcf2bd01e2fd38d";

export default node;
